import { setLanguage } from "config/language";
import Banner from "../common/Banner";
import { useEffect, useState } from "react";
import BazAIHelmet from "../common/BazAIHelmet";
import { baseUrl } from "config/apiUrl";
import { supplierPageData, supplierFAQs } from "./supplierdata";
import UpdateNavbar from "pages/UpdatedLanding/Common/UpdateNavbar";
import UpdateFooter from "pages/UpdatedLanding/Common/UpdateFooter";
import EnhancedPageLayout from "pages/UpdatedLanding/Common/EnhancedPageLayout";

export default function LandingForSupplierManagement() {
  const [scrollTop, setScrollTop] = useState(0);
  useEffect(() => {
    function onScroll() {
      setScrollTop(document.documentElement.scrollTop);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);
  if (localStorage.getItem("lan") === null) {
    setLanguage();
  }

  return (
    <div className="bg-slate-50 min-h-screen">
      <BazAIHelmet
        title="Supplier Management Software — Build a Resilient Supply Chain with AI"
        description="EkkBaz AI Supplier Management reduces supply chain risk by 60%, achieves 97%+ on-time delivery, and increases procurement efficiency 80% — with AI supplier scoring, risk monitoring, and digital onboarding."
        keywords="supplier management software, supply chain risk management, supplier performance scoring, procurement AI, vendor management software, supplier onboarding"
        image="/assets/images/LogoAI.png"
        url={`${baseUrl.webUrl}/product/supplier`}
        productName="Supplier Management"
        faqItems={supplierFAQs}
      />
      <UpdateNavbar />
      <Banner
        headline="Supplier Management"
        subtitle="AI supplier scoring, proactive risk monitoring, and digital onboarding — building the resilient supply chain your business needs to thrive."
        from="supplier"
      />
      <EnhancedPageLayout {...supplierPageData} />
      <UpdateFooter />
    </div>
  );
}
